import gql from 'graphql-tag';
const DRAG_AND_DROP_ACTIVITY_FRAGMENT = gql `
  fragment DragAndDropActivityFragment on DragAndDropActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
      }
    }
    rounds {
      hint {
        id
        audioId
        audio {
          id
          src
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
        }
      }
      dynamicContent {
        layout
        items {
          textHtml {
            id
            elements
          }
          image {
            id
            imageId
            image {
              id
              src
            }
          }
          table {
            labelHtml {
              id
              elements
            }
            headers {
              label
              columnType
            }
            rows {
              values {
                value
                correct
              }
            }
          }
          scrollableText {
            id
            width
            height
            textHtml {
              id
              elements
            }
          }
        }
      }
      typeOverText {
        id
        text
        directionsHtml {
          id
          elements
        }
        instructions {
          id
          audioId
          audio {
            src
          }
        }
      }
      draggableItems {
        id
        label
        image {
          id
          imageId
          image {
            src
          }
        }
      }
      dropZones {
        id
        titleHtml {
          id
          elements
        }
        leftHtml {
          id
          elements
        }
        rightHtml {
          id
          elements
        }
        correctItemIds
        fixedItems {
          id
          label
          image {
            imageId
            image {
              src
            }
          }
        }
      }
      table {
        labelHtml {
          id
          elements
        }
        headers {
          label
          columnType
        }
        rows {
          values {
            value
            correct
            placeholder
          }
        }
      }
    }
  }
`;
export default DRAG_AND_DROP_ACTIVITY_FRAGMENT;
